var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-subpage"},[_c('div',{staticClass:"subbar"},[_c('div',{staticClass:"wrap"},[_c('wx-menutab',{attrs:{"menus":_vm.menus,"activeKey":_vm.activeKey,"lazy":_vm.lazy},on:{"clickMenu":_vm.clickMenu}})],1)]),_vm._v(" "),_c('div',{staticClass:"page-wrap",style:(_vm.pageWrapStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76547732","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Subpage.vue
// module id = null
// module chunks = 